<div class="header">
	<div class="block-1" [routerLink]="['/']">
		<mat-icon class="icon" svgIcon="logo-header"></mat-icon>
	</div>
	<div class="block-2">
		<a href="javascript:void(0)"><img src="./assets/images/header/h-google.png" alt="Google Icon"></a>
		<a href="javascript:void(0)"><img src="./assets/images/header/h-apple.png" alt="App Store Icon"></a>
	</div>
</div>
<div class="profile-container">
	<div class="title-block">
		<h3 class="reset-password">My Profile</h3>
	</div>
	<div class="form-container">
		<div></div>
		<div>
			<form [formGroup]=form (autocomplete)="'false'" (submit)="onSubmit(form)">
				<div class="form-group col-xs-12 col-sm-4 col-md-4 col-lg-4">
					<label>Title<sup class="error">*</sup></label>
					<app-select
						[values]="[{value:'Mr', label:'Mr'}, {value: 'Mrs', label: 'Mrs'}, {value: 'Ms', label: 'Ms'}]"
						[selectedValue]=form.value.title [style]="'none'"
						(onValueChange)="form.controls.title.setValue($event);markTouchedAndDirty($event, 'title')"></app-select>
					<p class="error"
						*ngIf="form.get('title')?.invalid && (form.get('title')?.dirty || form.get('title')?.touched)">
						Please select Title
					</p>
				</div>
				<div class="form-group col-xs-12 col-sm-4 col-md-4 col-lg-4">
					<label>First Name<sup class="error">*</sup></label>
					<app-input (onChangeEvent)="form.controls.firstName.setValue($event)"
						(onFocusOutEvent)="markTouchedAndDirty($event, 'firstName')"
						[value]="form.value.firstName"></app-input>
					<p class="error"
						*ngIf="form.get('firstName')?.invalid && (form.get('firstName')?.dirty || form.get('firstName')?.touched)">
						Please enter valid First Name
					</p>
				</div>
				<div class="form-group col-xs-12 col-sm-4 col-md-4 col-lg-4">
					<label>Last Name<sup class="error">*</sup></label>
					<app-input (onChangeEvent)="form.controls.lastName.setValue($event)"
						(onFocusOutEvent)="markTouchedAndDirty($event, 'lastName')"
						[value]="form.value.lastName"></app-input>
					<p class="error"
						*ngIf="form.get('lastName')?.invalid && (form.get('lastName')?.dirty || form.get('lastName')?.touched)">
						Please enter valid Last Name
					</p>
				</div>
				<div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
					<label>Email<sup class="error">*</sup></label>
					<app-input [disabled]="false" (onChangeEvent)="form.controls.emailId.setValue($event)"
						(onFocusOutEvent)="markTouchedAndDirty($event, 'emailId')"
						[value]="form.value.emailId"></app-input>
					<p class="error"
						*ngIf="form.get('emailId')?.invalid && (form.get('emailId')?.dirty || form.get('emailId')?.touched)">
						Please enter valid Email
					</p>
				</div>

				<div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12" *ngIf="form.value.mobile">
					<label>Mobile<sup class="error">*</sup></label>
					<app-input [disabled]="true" (onChangeEvent)="form.controls.mobile.setValue($event)"
						(onFocusOutEvent)="markTouchedAndDirty($event, 'mobile')"
						[value]="form.value.mobile"></app-input>
					<p class="error"
						*ngIf="form.get('mobile')?.invalid && (form.get('mobile')?.dirty || form.get('mobile')?.touched)">
						Please enter valid mobile
					</p>
				</div>

				<div class="col-xs-12 col-sm-4 col-md-6 col-lg-4 text-center login-btn-block">
					<button type="submit" mat-button class="btn btn-block">Save</button>
				</div>
				<div class="col-xs-12 col-sm-4 col-md-6 col-lg-4 text-center delete-btn-block"
					(click)="deleteAccount()">
					<button type="button" mat-button class="btn btn-block">Delete Account</button>
				</div>
				<div class="col-xs-12 col-sm-4 col-md-6 col-lg-4 text-center login-btn-block">
					<!-- <button type="button" mat-button class="btn btn-block" [routerLink]="['/']">Back</button> -->
					<button type="button" mat-button class="btn btn-block" (click)="backBtnClick()">Back</button>
				</div>
			</form>
		</div>
		<div></div>
	</div>
</div>
<div class="footer">
	<div class="col-sm-12 col-xs-12 col-md-12 col-lg-12 px-0">
		<div class="col-sm-12 col-xs-12 col-md-6 col-lg-6 block-1">
			<p>© 2023 Ausmit. All right reserved.</p>
		</div>
		<div class="col-sm-12 col-xs-12 col-md-6 col-lg-6 text-right block-2">
			<a [routerLink]="['/termsandconditions']">Terms & Conditions</a>
			<span>|</span>
			<a [routerLink]="['/privacypolicy']">Privacy Policy</a>
		</div>
	</div>
</div>